module.exports = __webpack_public_path__ + "img/chevron-bottom.b58d83a0.svg";